import React from 'react';

export const ServiceStatsCards = ({ statistics }) => {
  if (!statistics) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      <div className="bg-white p-6 rounded-lg border border-zinc-200" data-testid="total-tickets-stat">
        <p className="text-sm text-zinc-600">Ümumi Ticketlər</p>
        <p className="text-3xl font-bold text-zinc-900 mt-2">{statistics.total_tickets}</p>
      </div>
      <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200" data-testid="warning-tickets-stat">
        <p className="text-sm text-yellow-800">Xəbərdarlıq (&gt;24h)</p>
        <p className="text-3xl font-bold text-yellow-900 mt-2">{statistics.warning_tickets}</p>
      </div>
      <div className="bg-red-50 p-6 rounded-lg border border-red-200" data-testid="critical-tickets-stat">
        <p className="text-sm text-red-800">Kritik (&gt;72h)</p>
        <p className="text-3xl font-bold text-red-900 mt-2">{statistics.critical_tickets}</p>
      </div>
      <div className="bg-white p-6 rounded-lg border border-zinc-200" data-testid="total-technicians-stat">
        <p className="text-sm text-zinc-600">Texniklər</p>
        <p className="text-3xl font-bold text-zinc-900 mt-2">{statistics.total_technicians}</p>
      </div>
    </div>
  );
};

export const ServiceStatusBreakdown = ({ statistics }) => {
  if (!statistics) return null;

  return (
    <div className="bg-white p-6 rounded-lg border border-zinc-200 mb-8">
      <h2 className="text-xl font-bold mb-4 text-zinc-900">Ticket Statusları</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div data-testid="pending-stat">
          <p className="text-sm text-zinc-600">Gözləyən</p>
          <p className="text-2xl font-bold text-zinc-900">{statistics.pending_tickets}</p>
        </div>
        <div data-testid="assigned-stat">
          <p className="text-sm text-zinc-600">Təyin olunmuş</p>
          <p className="text-2xl font-bold text-zinc-900">{statistics.assigned_tickets}</p>
        </div>
        <div data-testid="completed-stat">
          <p className="text-sm text-zinc-600">Tamamlanmış</p>
          <p className="text-2xl font-bold text-zinc-900">{statistics.completed_tickets}</p>
        </div>
        <div data-testid="closed-stat">
          <p className="text-sm text-zinc-600">Bağlanmış</p>
          <p className="text-2xl font-bold text-zinc-900">{statistics.closed_tickets}</p>
        </div>
      </div>
    </div>
  );
};

export const CategoryBreakdown = ({ statistics }) => {
  if (!statistics || (!statistics.by_category && !statistics.by_problem_type)) return null;
  
  const PROBLEM_TYPE_LABELS = {
    loss: 'Loss işığı (PON qırmızı)',
    no_ip: 'IP almır (PON yaşıl)',
    no_connection: 'İnternet yoxdur',
    other: 'Digər'
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      {/* Category Breakdown */}
      {statistics.by_category && Object.keys(statistics.by_category).length > 0 && (
        <div className="bg-white p-6 rounded-lg border border-zinc-200">
          <h3 className="text-lg font-bold mb-4 text-zinc-900">Kateqoriya üzrə</h3>
          <div className="space-y-3">
            {Object.entries(statistics.by_category).map(([category, count]) => (
              <div key={category} className="flex items-center justify-between">
                <span className="text-sm text-zinc-700 capitalize">{category}</span>
                <span className="font-bold text-zinc-900">{count}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {/* Problem Type Breakdown (Internet only) */}
      {statistics.by_problem_type && Object.keys(statistics.by_problem_type).length > 0 && (
        <div className="bg-white p-6 rounded-lg border border-zinc-200">
          <h3 className="text-lg font-bold mb-4 text-zinc-900">İnternet problem növləri</h3>
          <div className="space-y-3">
            {Object.entries(statistics.by_problem_type).map(([type, count]) => (
              <div key={type} className="flex items-center justify-between">
                <span className="text-sm text-zinc-700">{PROBLEM_TYPE_LABELS[type] || type}</span>
                <span className="font-bold text-zinc-900">{count}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceStatsCards;
